// extracted by mini-css-extract-plugin
export default {"page":"n0-z","cartModal":"o0-z","checkout":"p0-z","placeholder":"q0-z","account":"r0-z"};